module.exports = {"610702001":"北关街道","610702002":"东大街街道","610702003":"汉中路街道","610702004":"中山街街道","610702005":"东关街道","610702006":"鑫源街道","610702008":"七里街道","610702009":"龙江街道","610702100":"铺镇","610702101":"武乡镇","610702102":"河东店镇","610702104":"宗营镇","610702105":"老君镇","610702106":"汉王镇","610702107":"徐望镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610702.json
// module id = 2985
// module chunks = 0